import WaveSurfer from 'wavesurfer.js';

$('.AudioPlayer').each(function (i, el) {
	const audioSrc = $(el).attr('data-audio-src');
	const $button = $(el).find('.AudioPlayer-button');

	if (audioSrc) {
		const wavesurfer = WaveSurfer.create({
			container: $(el).find('.AudioPlayer-path')[0],
			waveColor: 'grey',
			progressColor: '#e64926',
			height: 60,
			backend: 'MediaElement',
			mediaType:'audio',
			normalize: true,
			barWidth: 3
		});

		//Set song
		wavesurfer.song = audioSrc;

		//Set peaks
		wavesurfer.backend.peaks = [0.0218, 0.0183, 0.0165, 0.0198, 0.2137, 0.2888, 0.2313, 0.15, 0.2542, 0.2538, 0.2358, 0.1195, 0.1591, 0.2599, 0.2742, 0.1447, 0.2328, 0.1878, 0.1988, 0.1645, 0.1218, 0.2005, 0.2828, 0.2051, 0.1664, 0.1181, 0.1621, 0.2966, 0.189, 0.246, 0.2445, 0.1621, 0.1618, 0.189, 0.2354, 0.1561, 0.1638, 0.2799, 0.0923, 0.1659, 0.1675, 0.1268, 0.0984, 0.0997, 0.1248, 0.1495, 0.1431, 0.1236, 0.1755, 0.1183, 0.1349, 0.1018, 0.1109, 0.1833, 0.1813, 0.1422, 0.0961, 0.1191, 0.0791, 0.0631, 0.0315, 0.0157, 0.0166, 0.0108];

		//Draw peaks
		wavesurfer.drawBuffer();

		//Variable to check if song is loaded
		wavesurfer.loaded = false;

		//Start playing after song is loaded
		wavesurfer.on("ready", () => {
			if(!wavesurfer.loaded) {
				$button.removeClass('loading');
				wavesurfer.loaded = true;
				wavesurfer.play();
			}
		});

		wavesurfer.on('finish', () => {
			const $img = $(el).find('.AudioPlayer-button img');
			$img.attr('src', '/local/templates/dara/img/play.png');
			$img.removeClass('play');
		});

		$button.on('click', ({ target, currentTarget }) => {


			const $img = $(currentTarget).find('img');
			$img.toggleClass('play');

			if ($img.hasClass('play')) {
				$img.attr('src', '/local/templates/dara/img/pause.png');
				wavesurfer.play();
				if(!wavesurfer.loaded) {
					$(currentTarget).addClass('loading');
					wavesurfer.load(wavesurfer.song, wavesurfer.backend.peaks);
				}

			} else {
				$img.attr('src', '/local/templates/dara/img/play.png');
				wavesurfer.pause();
			}
		});

		console.log(2);
	}


});